import { Box, GridLegacy as Grid } from '@mui/material'

import BackToTop from 'src/pages/HomepageSpringLaunch2024Page/components/common/BackToTop'
import Footer from 'src/pages/HomepageSpringLaunch2024Page/components/common/Footer'
import Header from 'src/pages/HomepageSpringLaunch2024Page/components/common/Header'

type PublicSiteLayoutProps = {
  children?: React.ReactNode
}

const PublicSiteLayout = ({ children }: PublicSiteLayoutProps) => {
  return (
    <Box
      sx={{
        background: (theme) => theme.palette.background.default,
        width: '100%',
        height: '100%',
        m: 0,
        p: 0,
        '& p, & h2, & h3, & h4, & h5, & h6': {
          color: 'primary.main',
        },
      }}
    >
      <BackToTop />
      <Header />
      <Grid container>
        <Grid
          item
          xs={0}
          sm={0}
          md={2}
          lg={2}
          xl={2}
        />
        <Grid
          item
          xs={12}
          sm={12}
          md={8}
          lg={8}
          xl={8}
        >
          {children}
        </Grid>
        <Grid
          item
          xs={0}
          sm={0}
          md={2}
          lg={2}
          xl={2}
        />
      </Grid>
      <Footer />
    </Box>
  )
}

export default PublicSiteLayout
